import React from 'react'

import { Helmet } from 'react-helmet'

import './partners.css'

const Partners = (props) => {
  return (
    <div className="partners-container">
      <Helmet>
        <title>
          Partners - FutureHeirs | Faith-Based Non-Profit Empowering Future
          Leaders
        </title>
        <meta
          name="description"
          content="Faith-based non-profit bridging quality education and accessibility. Empowering children through Christ-centered learning, tech literacy &amp; character development"
        />
        <meta
          property="og:title"
          content="Partners - FutureHeirs | Faith-Based Non-Profit Empowering Future Leaders"
        />
        <meta
          property="og:description"
          content="Bridging quality education and accessibility through Christ-centered learning. Empowering every child to flourish in their unique calling with faith and innovation."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/97765a8c-e132-4703-821d-7a550778f912/2688ccf9-cb16-49f3-aba4-ad25e1010654?org_if_sml=1&amp;force_format=original"
        />
      </Helmet>
      <div className="partners-partners">
        <div className="partners-frame12">
          <div className="partners-frame14">
            <div className="partners-frame162">
              <img
                alt="VectorI372"
                src="/external/vectori372-346q.svg"
                className="partners-vector10"
              />
              <span className="partners-text100">futureheirs</span>
            </div>
            <div className="partners-frame81">
              <div className="partners-frame6">
                <span className="partners-text101">Home</span>
              </div>
              <div className="partners-frame7">
                <span className="partners-text102">About Us</span>
              </div>
              <div className="partners-frame82">
                <span className="partners-text103">Contact Us</span>
              </div>
              <div className="partners-frame9">
                <span className="partners-text104">Blog</span>
              </div>
            </div>
            <div className="partners-component41">
              <span className="partners-text105">Join Us</span>
            </div>
          </div>
          <div className="partners-frame13">
            <div className="partners-frame195">
              <img
                alt="Line653724"
                src="/external/line653724-y7ol.svg"
                className="partners-line65"
              />
              <span className="partners-text106">Join Our Mission</span>
            </div>
            <span className="partners-text107">
              Be a part of something bigger empower the next generation through
              education and leadership.
            </span>
          </div>
        </div>
        <img
          alt="Rectangle43724"
          src="/external/rectangle43724-j8yl.svg"
          className="partners-rectangle4"
        />
        <div className="partners-frame3098">
          <div className="partners-frame3097">
            <div className="partners-component10">
              <div className="partners-component8">
                <div className="partners-frame219">
                  <span className="partners-text108">Partner with Us</span>
                </div>
                <div className="partners-frame220">
                  <span className="partners-text109">Volunteer with Us</span>
                </div>
              </div>
              <div className="partners-frame30911">
                <div className="partners-frame3063">
                  <img
                    alt="excitedmulattowomanwithcurlyhairstyleposingwiththuI391"
                    src="/external/excitedmulattowomanwithcurlyhairstyleposingwiththui391-gnj-500w.png"
                    className="partners-excitedmulattowomanwithcurlyhairstyleposingwiththu"
                  />
                  <div className="partners-frame30591">
                    <div className="partners-frame21">
                      <span className="partners-text110">
                        Become a FutureHeirs Partner
                      </span>
                    </div>
                    <span className="partners-text111">
                      Partnership is at the heart of how we fulfill our mission.
                      By combining resources, expertise, and passion, we can
                      make a greater impact in the lives of children and
                      communities. We invite organizations and individuals who
                      share our vision to join us as partners in empowering the
                      next generation.
                    </span>
                  </div>
                </div>
                <div className="partners-frame3062">
                  <span className="partners-text112">
                    Partnership Opportunities
                  </span>
                  <div className="partners-frame3076">
                    <div className="partners-frame3074">
                      <div className="partners-frame30701">
                        <img
                          alt="schoolsvgrepocom1I391"
                          src="/external/schoolsvgrepocom1i391-a1n7.svg"
                          className="partners-schoolsvgrepocom1"
                        />
                        <div className="partners-frame30691">
                          <div className="partners-frame30711">
                            <span className="partners-text113">
                              Schools &amp; Educational Institutions
                            </span>
                          </div>
                          <div className="partners-frame30661">
                            <div className="partners-frame30651">
                              <img
                                alt="Ellipse185I391"
                                src="/external/ellipse185i391-tklo-200h.png"
                                className="partners-ellipse18510"
                              />
                              <span className="partners-text114">
                                Implement our tech curriculum in your classrooms
                              </span>
                            </div>
                            <div className="partners-frame30662">
                              <img
                                alt="Ellipse185I391"
                                src="/external/ellipse185i391-ce1u-200h.png"
                                className="partners-ellipse18511"
                              />
                              <span className="partners-text115">
                                Host holiday tech camps and workshops
                              </span>
                            </div>
                            <div className="partners-frame30671">
                              <img
                                alt="Ellipse185I391"
                                src="/external/ellipse185i391-ja7j-200h.png"
                                className="partners-ellipse18512"
                              />
                              <span className="partners-text116">
                                Collaborate on teacher training initiatives
                              </span>
                            </div>
                            <div className="partners-frame30681">
                              <img
                                alt="Ellipse185I391"
                                src="/external/ellipse185i391-83r8-200h.png"
                                className="partners-ellipse18513"
                              />
                              <span className="partners-text117">
                                Provide internship opportunities for program
                                graduates
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="partners-frame30712">
                        <div className="partners-vuesaxboldbuliding1">
                          <div className="partners-vuesaxboldbuliding2">
                            <div className="partners-buliding">
                              <img
                                alt="VectorI391"
                                src="/external/vectori391-vixs.svg"
                                className="partners-vector11"
                              />
                              <img
                                alt="VectorI391"
                                src="/external/vectori391-ew8le.svg"
                                className="partners-vector12"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="partners-frame30692">
                          <div className="partners-frame30713">
                            <span className="partners-text118">
                              Businesses &amp; Corporations
                            </span>
                          </div>
                          <div className="partners-frame30663">
                            <div className="partners-frame30652">
                              <img
                                alt="Ellipse185I391"
                                src="/external/ellipse185i391-p8b-200h.png"
                                className="partners-ellipse18514"
                              />
                              <span className="partners-text119">
                                Sponsor a Tech Innovation Center
                              </span>
                            </div>
                            <div className="partners-frame30664">
                              <img
                                alt="Ellipse185I391"
                                src="/external/ellipse185i391-ui8a-200h.png"
                                className="partners-ellipse18515"
                              />
                              <span className="partners-text120">
                                Provide industry mentors and guest speakers
                              </span>
                            </div>
                            <div className="partners-frame30672">
                              <img
                                alt="Ellipse185I391"
                                src="/external/ellipse185i391-a28v-200h.png"
                                className="partners-ellipse18516"
                              />
                              <span className="partners-text121">
                                Offer internships and career exposure for
                                students
                              </span>
                            </div>
                            <div className="partners-frame30682">
                              <img
                                alt="Ellipse185I391"
                                src="/external/ellipse185i391-fz0b-200h.png"
                                className="partners-ellipse18517"
                              />
                              <span className="partners-text122">
                                Contribute equipment, software, or technical
                                expertise
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="partners-frame3075">
                      <div className="partners-frame30721">
                        <img
                          alt="churchsvgrepocom1I391"
                          src="/external/churchsvgrepocom1i391-dwb.svg"
                          className="partners-churchsvgrepocom1"
                        />
                        <div className="partners-frame30693">
                          <div className="partners-frame30714">
                            <span className="partners-text123">
                              Churches &amp; Faith Communities
                            </span>
                          </div>
                          <div className="partners-frame30665">
                            <div className="partners-frame30653">
                              <img
                                alt="Ellipse185I391"
                                src="/external/ellipse185i391-kkvb-200h.png"
                                className="partners-ellipse18518"
                              />
                              <span className="partners-text124">
                                Host a Community Learning Hub
                              </span>
                            </div>
                            <div className="partners-frame30666">
                              <img
                                alt="Ellipse185I391"
                                src="/external/ellipse185i391-81fx-200h.png"
                                className="partners-ellipse18519"
                              />
                              <span className="partners-text125">
                                Sponsor students from your
                                congregation/community
                              </span>
                            </div>
                            <div className="partners-frame30673">
                              <img
                                alt="Ellipse185I391"
                                src="/external/ellipse185i391-2r8-200h.png"
                                className="partners-ellipse18520"
                              />
                              <span className="partners-text126">
                                Mobilize volunteers for mentorship programs
                              </span>
                            </div>
                            <div className="partners-frame30683">
                              <img
                                alt="Ellipse185I391"
                                src="/external/ellipse185i391-eixp-200h.png"
                                className="partners-ellipse18521"
                              />
                              <span className="partners-text127">
                                Co-develop faith-integrated educational
                                materials
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="partners-frame3073">
                        <img
                          alt="handshakedealsvgrepocom1I391"
                          src="/external/handshakedealsvgrepocom1i391-b55v.svg"
                          className="partners-handshakedealsvgrepocom1"
                        />
                        <div className="partners-frame30694">
                          <div className="partners-frame30715">
                            <span className="partners-text128">
                              Non-Profit Organizations
                            </span>
                          </div>
                          <div className="partners-frame30667">
                            <div className="partners-frame30654">
                              <img
                                alt="Ellipse185I391"
                                src="/external/ellipse185i391-ay9-200h.png"
                                className="partners-ellipse18522"
                              />
                              <span className="partners-text129">
                                Collaborate on grant proposals and funding
                                initiatives
                              </span>
                            </div>
                            <div className="partners-frame30668">
                              <img
                                alt="Ellipse185I391"
                                src="/external/ellipse185i391-yzxr-200h.png"
                                className="partners-ellipse18523"
                              />
                              <span className="partners-text130">
                                Share resources and best practices
                              </span>
                            </div>
                            <div className="partners-frame30674">
                              <img
                                alt="Ellipse185I391"
                                src="/external/ellipse185i391-cf6-200h.png"
                                className="partners-ellipse18524"
                              />
                              <span className="partners-text131">
                                Coordinate complementary programs and services
                              </span>
                            </div>
                            <div className="partners-frame30684">
                              <img
                                alt="Ellipse185I391"
                                src="/external/ellipse185i391-l1po-200h.png"
                                className="partners-ellipse18525"
                              />
                              <span className="partners-text132">
                                Co-host community events and workshops
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="partners-component42">
                    <span className="partners-text133">Become a Partner</span>
                  </div>
                </div>
                <div className="partners-frame3081">
                  <span className="partners-text134">Partner Benefits</span>
                  <div className="partners-frame3080">
                    <div className="partners-frame3078">
                      <div className="partners-frame30702">
                        <img
                          alt="checkcirclesvgrepocom1I391"
                          src="/external/checkcirclesvgrepocom1i391-77oj.svg"
                          className="partners-checkcirclesvgrepocom1"
                        />
                        <div className="partners-frame30695">
                          <span className="partners-text135">
                            Meaningful Impact
                          </span>
                          <span className="partners-text136">
                            Directly contribute to transforming young lives.
                          </span>
                        </div>
                      </div>
                      <div className="partners-frame30716">
                        <img
                          alt="briefcasesvgrepocom1I391"
                          src="/external/briefcasesvgrepocom1i391-5m9.svg"
                          className="partners-briefcasesvgrepocom1"
                        />
                        <div className="partners-frame30696">
                          <span className="partners-text137">
                            Employee Engagement
                          </span>
                          <span className="partners-text138">
                            Meaningful volunteer opportunities for your team.
                          </span>
                        </div>
                      </div>
                      <div className="partners-frame30722">
                        <img
                          alt="handshakesvgrepocom1I391"
                          src="/external/handshakesvgrepocom1i391-gfqm.svg"
                          className="partners-handshakesvgrepocom1"
                        />
                        <div className="partners-frame30697">
                          <span className="partners-text139">
                            Collaborative Growth
                          </span>
                          <span className="partners-text140">
                            Mutual learning and capacity building.
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="partners-frame3079">
                      <div className="partners-frame30703">
                        <img
                          alt="userssvgrepocom11I391"
                          src="/external/userssvgrepocom11i391-gpwu.svg"
                          className="partners-userssvgrepocom11"
                        />
                        <div className="partners-frame30698">
                          <span className="partners-text141">
                            Community Recognition
                          </span>
                          <span className="partners-text142">
                            Visibility as a champion for education.
                          </span>
                        </div>
                      </div>
                      <div className="partners-frame30717">
                        <img
                          alt="graphsvgrepocom1I391"
                          src="/external/graphsvgrepocom1i391-r3j8.svg"
                          className="partners-graphsvgrepocom1"
                        />
                        <div className="partners-frame30699">
                          <span className="partners-text143">
                            Custom Reporting
                          </span>
                          <span className="partners-text144">
                            Regular updates on program outcomes and impact.
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="partners-frame3084">
                  <img
                    alt="closeupafricanamericanphysiciandoctorexplainingheaI391"
                    src="/external/closeupafricanamericanphysiciandoctorexplainingheai391-s5v9-500w.png"
                    className="partners-closeupafricanamericanphysiciandoctorexplaininghea"
                  />
                  <div className="partners-frame3088">
                    <div className="partners-frame30592">
                      <span className="partners-text145">
                        Partnership Process
                      </span>
                      <div className="partners-frame3085">
                        <span className="partners-text146">
                          <span className="partners-text147">
                            Initial Consultation:
                          </span>
                          <span>
                            {' '}
                            We&apos;ll discuss your organization&apos;s goals
                            and how they align with our mission
                          </span>
                        </span>
                        <span className="partners-text149">
                          <span className="partners-text150">
                            Customized Partnership Plan:
                          </span>
                          <span>
                            {' '}
                            Together, we&apos;ll develop a partnership strategy
                            that maximizes impact
                          </span>
                        </span>
                        <span className="partners-text152">
                          <span className="partners-text153">Agreement:</span>
                          <span>
                            {' '}
                            We&apos;ll formalize our partnership with clear
                            expectations and commitments
                          </span>
                        </span>
                        <span className="partners-text155">
                          <span className="partners-text156">Launch:</span>
                          <span>
                            {' '}
                            We&apos;ll implement our collaborative initiatives
                          </span>
                        </span>
                        <span className="partners-text158">
                          <span className="partners-text159">
                            Ongoing Collaboration:
                          </span>
                          <span>
                            {' '}
                            Regular check-ins to evaluate progress and refine
                            our approach
                          </span>
                        </span>
                      </div>
                    </div>
                    <div className="partners-component43">
                      <span className="partners-text161">
                        Request Partnership Information
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="partners-frame3089">
              <span className="partners-text162">
                Partner and Volunteer Testimonials
              </span>
              <div className="partners-component13">
                <div className="partners-frame146">
                  <div className="partners-frame1521">
                    <div className="partners-frame1531">
                      <div className="partners-frame1591">
                        <img
                          alt="Ellipse5I391"
                          src="/external/ellipse5i391-xhs-200h.png"
                          className="partners-ellipse5"
                        />
                        <div className="partners-frame1522">
                          <span className="partners-text163">
                            Pastor Michael Johnson
                          </span>
                          <span className="partners-text164">
                            Grace Community Church
                          </span>
                        </div>
                      </div>
                      <div className="partners-vuesaxboldquotedown1">
                        <div className="partners-vuesaxboldquotedown2">
                          <div className="partners-quotedown1">
                            <img
                              alt="VectorI391"
                              src="/external/vectori391-miwf.svg"
                              className="partners-vector13"
                            />
                            <img
                              alt="VectorI391"
                              src="/external/vectori391-kgtd.svg"
                              className="partners-vector14"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <span className="partners-text165">
                      Partnering with FutureHeirs has allowed our church to
                      extend our impact in the community in ways we never
                      imagined. The children in our Learning Hub aren&apos;t
                      just gaining technical skills; they&apos;re discovering
                      their God-given purpose.
                    </span>
                  </div>
                  <div className="partners-frame1532">
                    <div className="partners-frame1541">
                      <div className="partners-frame1592">
                        <img
                          alt="Ellipse6I391"
                          src="/external/ellipse6i391-ad5n-200h.png"
                          className="partners-ellipse61"
                        />
                        <div className="partners-frame1523">
                          <span className="partners-text166">
                            Sarah Williams
                          </span>
                          <span className="partners-text167">
                            Software Engineer &amp; Volunteer Mentor
                          </span>
                        </div>
                      </div>
                      <div className="partners-vuesaxboldquotedown3">
                        <div className="partners-vuesaxboldquotedown4">
                          <div className="partners-quotedown2">
                            <img
                              alt="VectorI391"
                              src="/external/vectori391-pfds.svg"
                              className="partners-vector15"
                            />
                            <img
                              alt="VectorI391"
                              src="/external/vectori391-0di.svg"
                              className="partners-vector16"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <span className="partners-text168">
                      As a tech professional, volunteering with FutureHeirs has
                      been incredibly rewarding. Seeing the students&apos; faces
                      light up when they successfully complete a coding project
                      reminds me why I got into this field in the first place.
                    </span>
                  </div>
                  <div className="partners-frame1542">
                    <div className="partners-frame1543">
                      <div className="partners-frame1593">
                        <img
                          alt="Ellipse6I391"
                          src="/external/ellipse6i391-frlj-200h.png"
                          className="partners-ellipse62"
                        />
                        <div className="partners-frame1524">
                          <span className="partners-text169">David Chen</span>
                          <span className="partners-text170">
                            CEO of TechFuture Solutions
                          </span>
                        </div>
                      </div>
                      <div className="partners-vuesaxboldquotedown5">
                        <div className="partners-vuesaxboldquotedown6">
                          <div className="partners-quotedown3"></div>
                        </div>
                      </div>
                    </div>
                    <span className="partners-text171">
                      Our company&apos;s partnership with FutureHeirs has been a
                      win-win. We&apos;re helping prepare the next generation of
                      tech talent while providing our employees with meaningful
                      volunteer opportunities that boost morale and purpose.
                    </span>
                  </div>
                </div>
                <img
                  alt="Rectangle6I391"
                  src="/external/rectangle6i391-k90f-300w.png"
                  className="partners-rectangle6"
                />
                <img
                  alt="Frame109I391"
                  src="/external/frame109i391-wd9r.svg"
                  className="partners-frame109"
                />
              </div>
            </div>
            <div className="partners-frame3096">
              <div className="partners-frame30593">
                <div className="partners-frame3092">
                  <span className="partners-text172">Contact Us</span>
                  <span className="partners-text173">
                    Ready to get involved? We&apos;d love to hear from you!
                  </span>
                </div>
                <div className="partners-component44">
                  <span className="partners-text174">
                    Schedule a Conversation
                  </span>
                </div>
              </div>
              <div className="partners-frame3093">
                <div className="partners-frame18">
                  <div className="partners-frame191">
                    <div className="partners-group401">
                      <img
                        alt="Ellipse13913"
                        src="/external/ellipse13913-qb6-200h.png"
                        className="partners-ellipse11"
                      />
                      <div className="partners-vuesaxboldcall1">
                        <div className="partners-vuesaxboldcall2">
                          <div className="partners-call1">
                            <img
                              alt="Vector3913"
                              src="/external/vector3913-xvyc.svg"
                              className="partners-vector17"
                            />
                            <img
                              alt="Vector3913"
                              src="/external/vector3913-gld.svg"
                              className="partners-vector18"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <span className="partners-text175">
                      For Partnership Inquiries
                    </span>
                  </div>
                  <div className="partners-frame3094">
                    <span className="partners-text176">
                       partnerships@futureheirs.org
                    </span>
                    <span className="partners-text177">
                      (555) 123-4567 ext. 3
                    </span>
                  </div>
                </div>
                <div className="partners-frame30912">
                  <div className="partners-frame192">
                    <div className="partners-group402">
                      <img
                        alt="Ellipse13913"
                        src="/external/ellipse13913-i5ve-200h.png"
                        className="partners-ellipse12"
                      />
                      <div className="partners-vuesaxboldcall3">
                        <div className="partners-vuesaxboldcall4">
                          <div className="partners-call2">
                            <img
                              alt="Vector3913"
                              src="/external/vector3913-16g.svg"
                              className="partners-vector19"
                            />
                            <img
                              alt="Vector3913"
                              src="/external/vector3913-rso8.svg"
                              className="partners-vector20"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <span className="partners-text178">
                      For Volunteer Opportunities
                    </span>
                  </div>
                  <div className="partners-frame3095">
                    <span className="partners-text179">
                      volunteer@futureheirs.org
                    </span>
                    <span className="partners-text180">
                      (555) 123-4567 ext. 4
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="partners-frame189">
            <div className="partners-frame184">
              <div className="partners-group107">
                <span className="partners-text181">Company</span>
                <div className="partners-frame2491">
                  <span className="partners-text182">Home</span>
                  <span className="partners-text183">About Us</span>
                  <span className="partners-text184">Contact Us</span>
                  <span className="partners-text185">Programs</span>
                  <span className="partners-text186">Approach</span>
                </div>
              </div>
              <div className="partners-group106">
                <span className="partners-text187">Quick Links</span>
                <div className="partners-frame2492">
                  <span className="partners-text188">Partner with Us</span>
                  <span className="partners-text189">Volunteer</span>
                  <span className="partners-text190">Donate</span>
                  <span className="partners-text191">Blog</span>
                </div>
              </div>
              <div className="partners-group105">
                <span className="partners-text192">Terms and Policies</span>
                <div className="partners-frame248">
                  <span className="partners-text193">Privacy Policy</span>
                  <span className="partners-text194">Terms and Conditions</span>
                  <span className="partners-text195">Feedback</span>
                  <span className="partners-text196">FAQs</span>
                </div>
              </div>
              <div className="partners-group104">
                <span className="partners-text197">Contact Information</span>
                <div className="partners-group87">
                  <span className="partners-text198">
                    connect@futureheirs.org
                  </span>
                  <div className="partners-vuesaxboldsms1">
                    <div className="partners-vuesaxboldsms2">
                      <div className="partners-sms">
                        <img
                          alt="VectorI372"
                          src="/external/vectori372-76pf.svg"
                          className="partners-vector21"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="partners-group88">
                  <span className="partners-text199">
                    123 Faith &amp; Innovation Way, Your City, State 12345
                  </span>
                  <div className="partners-vuesaxboldlocation1">
                    <div className="partners-vuesaxboldlocation2">
                      <img
                        alt="VectorI372"
                        src="/external/vectori372-mtk6.svg"
                        className="partners-vector22"
                      />
                    </div>
                  </div>
                </div>
                <div className="partners-group89">
                  <span className="partners-text200">(555) 123-4567</span>
                  <div className="partners-vuesaxboldcall5">
                    <div className="partners-vuesaxboldcall6">
                      <div className="partners-call3">
                        <img
                          alt="VectorI372"
                          src="/external/vectori372-8byl.svg"
                          className="partners-vector23"
                        />
                        <img
                          alt="VectorI372"
                          src="/external/vectori372-ljcx.svg"
                          className="partners-vector24"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img
              alt="Line2I372"
              src="/external/line2i372-d8ko.svg"
              className="partners-line2"
            />
            <div className="partners-frame183">
              <div className="partners-frame161">
                <img
                  alt="VectorI372"
                  src="/external/vectori372-b7z9.svg"
                  className="partners-vector25"
                />
                <span className="partners-text201">futureheirs</span>
              </div>
              <div className="partners-frame180">
                <span className="partners-text202">Follow Us:</span>
                <div className="partners-frame177">
                  <div className="partners-vuesaxboldfacebook1">
                    <div className="partners-vuesaxboldfacebook2">
                      <div className="partners-facebook">
                        <img
                          alt="VectorI372"
                          src="/external/vectori372-cn8r.svg"
                          className="partners-vector26"
                        />
                      </div>
                    </div>
                  </div>
                  <img
                    alt="riinstagramfillI372"
                    src="/external/riinstagramfilli372-khf.svg"
                    className="partners-riinstagramfill"
                  />
                  <img
                    alt="pajamaslinkedinI372"
                    src="/external/pajamaslinkedini372-f4ud.svg"
                    className="partners-pajamaslinkedin"
                  />
                  <img
                    alt="fa6brandssquarextwitterI372"
                    src="/external/fa6brandssquarextwitteri372-60h.svg"
                    className="partners-fa6brandssquarextwitter"
                  />
                  <div className="partners-vuesaxboldyoutube1">
                    <div className="partners-vuesaxboldyoutube2">
                      <div className="partners-youtube">
                        <img
                          alt="VectorI372"
                          src="/external/vectori372-pw4f.svg"
                          className="partners-vector27"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Partners
